"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgTwitter = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M34.424 15.183c.755-.533 1.766.156 1.548 1.054a8.72 8.72 0 01-1.995 3.774c.015.162.022.325.023.489 0 11.86-11.446 17.952-21.486 12.374-.92-.511-.527-1.915.526-1.873a10.64 10.64 0 004.874-.968c-2.204-1.358-3.615-3.157-4.308-5.285-.715-2.197-.61-4.505-.014-6.698.18-.663.364-1.163.494-1.456a1 1 0 011.732-.169A9.66 9.66 0 0023 20.507a5.48 5.48 0 019.133-4.122 9.9 9.9 0 002.29-1.202zm-2.276 3.305a1 1 0 01-1.043-.302A3.48 3.48 0 0025 20.53v1a1 1 0 01-.974 1 11.66 11.66 0 01-8.622-3.487c-.395 1.705-.424 3.464.104 5.086.677 2.081 2.227 3.77 4.898 4.957a1 1 0 01.156 1.741c-1.12.76-2.346 1.33-3.63 1.697C24.612 34.544 32 29.446 32 20.504a3.5 3.5 0 00-.062-.646 1 1 0 01.28-.9c.223-.22.429-.454.618-.7a11.9 11.9 0 01-.688.23z",
    id: "twitter_svg__a"
  }));
};

var _default = SvgTwitter;
exports.default = _default;